import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Deadwood,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const DeadwoodEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Deadwood),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type DeadwoodEntity = InferOutput<typeof DeadwoodEntitySchema>

/**
 * Area with dead or fallen trees, often creating natural obstacles and debris.
 */
export const DeadwoodEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Deadwood,
  dname: 'Deadwood',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 2,
  // blocksVision: false, // Main difference from Forest - doesn't block vision
  entDefaults,
}

export function createDeadwoodEntity(id: number, x: number, y: number): DeadwoodEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
